<div class="flex items-center justify-between">
  <div class="flex items-center gap-2">
    @if (icon()) {
      <ui-icon class="flex-shrink-0 text-gray-500" [icon]="icon()!" [size]="24"></ui-icon>
    }
    <h2 class="mb-0 truncate text-text-primary">{{ headline() }}</h2>
  </div>

  @if (hasActions()) {
    <div class="flex items-center gap-2">
      @if (secondaryAction()) {
        <ui-button
          size="sm"
          [label]="secondaryAction()!.label"
          (onClick)="secondaryAction()!.onClick()"
          [loading]="secondaryAction()!.loading || false"
          [disabled]="secondaryAction()!.disabled || false"
          variant="tertiary"></ui-button>
      }

      @if (primaryAction()) {
        <ui-button
          size="sm"
          [label]="primaryAction()!.label"
          (onClick)="primaryAction()!.onClick()"
          [loading]="primaryAction()!.loading || false"
          [disabled]="primaryAction()!.disabled || false"
          variant="primary"></ui-button>
      }
    </div>
  }
</div>

@if (subtext()) {
  <div class="text-base text-text-tertiary">{{ subtext() }}</div>
}

@if (learnMoreOptions()) {
  <div class="flex items-center gap-2">
    <span class="text-base text-text-primary">Learn more:</span>
    @for (option of learnMoreOptions()!; track option.label) {
      <a [href]="option.href" target="_blank" class="text-primary-500 font-semibold underline">{{ option.label }}</a>
    }
  </div>
}
